import React from "react";
import "./MissionSection.css"; // Import the CSS file for styling
import { Link } from "react-router";

const MissionSection = () => {
  return (
    <div className="mission-section">
      <div>
        <div className="row">
          <div className="col-9">
            <h2>Our Mission</h2>
            <p>
              One hand, extend support towards the basic necessity of life based
              on immediate need, and on the other hand, social long-term reform
              through education in the frame of sustainable development.
            </p>
            <button className="read-more-button"> <a href="https://www.youtube.com/watch?v=BCgjqSWvmfg" target="_blank"> View More..</a></button>
          </div>
          <div className="col-3">
            <div className="mission-images">
              <img
                src={`/assets/img/m-mission/mission.png`}
                alt="Support and education symbol"
                className="mission-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionSection;
